import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(root)/[...slug]/error.tsx");
